// src/api/mainApiSlice.ts
// import { RootState } from './store';
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccessToken } from "../features/auth/services/auth";

export const apiSlice = createApi({
  reducerPath: "mainApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/portal`,
    prepareHeaders: (headers, { getState }) => {
      const tok = getAccessToken();

      const token = tok;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
        headers.set("ngrok-skip-browser-warning", "69420");
      } else {
        console.warn("No token found in state!");
      }
      return headers;
    },
  }),
  tagTypes: ['fields', 'Contacts', 'components', 'widgets','builder'],
  endpoints: () => ({}),
});

export const { middleware: mainApiMiddleware } = apiSlice;
